import React, { Component } from "react";
import Content from "../components/Content";
import PriceList from "../components/Page/Pricing/PriceList";
import { Image } from "react-bootstrap";
import * as SvgAssets from "../components/SvgAssets";

export default class Pricing extends Component {
  render() {
    return (
      <section>
        <Content className="push-top" innerClassName="bg-white">
          <PriceList/>
        </Content>
        <Content innerClassName="fit-top">
          <div className="row">
            <div className="col-md-6">
              <h2>
                All Plans Comes Standard With These
                Features
                <hr/>
              </h2>
            </div>
            <div className="col-md-6">
              <ul className="price-features">
                <li>
                  <Image width={60} height={60} src={SvgAssets.apps} circle/><span>Core Apps</span>
                </li>
                <li>
                  <Image width={60} height={60} src={SvgAssets.supportBlue}
                         circle/><span>A+ Support</span>
                </li>
                <li>
                  <Image width={60} height={60} src={SvgAssets.update}
                         circle/><span>Software Update</span>
                </li>
                <li>
                  <Image width={60} height={60} src={SvgAssets.warranty} circle/><span>1-Year Hardware Warranty</span>
                </li>
              </ul>
            </div>
          </div>
        </Content>
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Pricing.js